import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D184F762-16C9-4266-A485-8AA14A83A575
 * name picture-in-picture-bottom-right
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/picture-in-picture-bottom-right.svg
 * tags
 */
export const PictureInPictureBottomRightIcon = createSvgIcon(<><path d="M19,11H11V17H19V11M23,19V5C23,3.88 22.1,3 21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19M21,19H3V4.97H21V19Z" /></>, 'PictureInPictureBottomRightIcon');
export default PictureInPictureBottomRightIcon